
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt-br/ia/recusas-de-carga",
      function () {
        return require("private-next-pages/pt-br/ia/recusas-de-carga/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt-br/ia/recusas-de-carga"])
      });
    }
  